import Icon from '../../components/Icon.vue'

Icon.register({"brands/google-plus":{"width":496,"height":512,"paths":[{"d":"M248 8C111.1 8 0 119.1 0 256S111.1 504 248 504 496 392.9 496 256 384.9 8 248 8zM177.3 380C108.5 380 53.3 324.5 53.3 256S108.5 132 177.3 132C208.6 132 237.4 143 260.3 164.3L226.7 196.9C213.5 184 195.4 177.8 177.3 177.8 134.4 177.8 100.1 213.3 100.1 255.9S134.3 334 177.3 334C209.9 334 242.2 314.9 247.4 280.7H177.3V238.1H294.2C295.5 244.9 296.1 251.7 296.1 258.8 296.1 329.6 248.6 380 177.3 380zM407.5 273.8V309.3H372V273.8H336.5V238.3H372V202.8H407.5V238.3H442.7V273.8H407.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/google-plus.js
// module id = M0+l
// module chunks = 0